import styled from 'styled-components';

export const CardList = styled.ul`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: 16px;
`;
